<script lang="ts">
  export let placeholder = '/blank.png';
  export let sources: { media: string; srcset: string; type: string }[] = [];
  export let src: string;
  export let alt: string | undefined = undefined;
  export let width: number;
  export let height: number;
  let className = '';
  export { className as class };

  import { onMount } from 'svelte';

  let imgElement: Element;
  let path = '/blank.png';
  let observer: IntersectionObserver;
  let intersected = false;
  let loaded = false;

  $: path = intersected ? src : placeholder;

  onMount(() => {
    observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          intersected = true;
          observer.unobserve(imgElement);
        }
      });
    });
    observer.observe(imgElement);
    return () => {
      observer.unobserve(imgElement);
    };
  });

  function handleLoad() {
    if (!loaded && path === src) {
      loaded = true;
    }
  }
</script>

<picture class="lazy-picture {className}" class:lazy-picture__loaded="{loaded}" {...$$restProps}>
  {#if path === src}
    {#each sources as source}
      <source media="{source.media}" srcset="{source.srcset}" type="{source.type}" />
    {/each}
  {/if}
  <img
    src="{path}"
    alt="{alt}"
    width="{width}"
    height="{height}"
    on:load="{handleLoad}"
    bind:this="{imgElement}"
  />
</picture>
<noscript>
  <picture class="{className}" {...$$restProps}>
    {#each sources as source}
      <source media="{source.media}" srcset="{source.srcset}" type="{source.type}" />
    {/each}
    <img src="{src}" alt="{alt}" width="{width}" height="{height}" />
  </picture>
</noscript>
